module.exports = __webpack_public_path__ + "static/img/Laura.10d3617.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/staff/Laura.jpg
// module id = 202
// module chunks = 1